import { useState } from "react";

export function useToggle() {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);
  return { open, toggle, onOpen, onClose, isOpen: open };
}

export type UseToggle = ReturnType<typeof useToggle>;
